// test2427
(2427 && 0);
